import React, { Fragment } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import injectSheet from 'react-jss';
import TextInput from '../../TextInput';
import Typography from '../../Typography';
import ApplyCouponButton from './ApplyCouponButton';

function CouponField({ classes, intl, onCouponApply, error }) {
  return (
    <Fragment>
      <div className={classes.root}>
        <Field
          component={TextInput}
          name="couponCode"
          label={<FormattedMessage id="promotionalCoupon" />}
          placeholder={intl.formatMessage({ id: 'pasteYourCodeHere' })}
        />
        <ApplyCouponButton onClick={onCouponApply} />
      </div>
      {error && (
        <Typography type="caption" className={classes.error}>
          {error}
        </Typography>
      )}
    </Fragment>
  );
}

CouponField.propTypes = {
  classes: PropTypes.object.isRequired,
  onCouponApply: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  error: PropTypes.string,
};

CouponField.defaultProps = {
  error: null,
};

const stylesheet = theme => ({
  root: {
    display: 'flex',
  },
  error: {
    color: theme.palette.error[500],
    marginTop: theme.spacing.unit,
  },
});

export default injectIntl(injectSheet(stylesheet)(CouponField));



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/Coupon/CouponField.js